export default __webpack_public_path__ + "static/background-compressed-medium-1aa360beae61c17b5564e2648b05e8d6.mp4";